import React, { useEffect, useState } from 'react';
import '../../../../../../../Stylesheets/Dashboard/Tabs/Labor/MarkAttendanceModal.css';
import { FaCalendarAlt } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { markIndividualAttendance, getWorkerAttendance } from '../../../../../../../Redux/Projects/Labor/laborSlice';
import { useParams } from 'react-router-dom';

const MarkAttendanceModal = ({ workerId, workerName, onClose = () => { } }) => {
  const dispatch = useDispatch();
  const { projectId } = useParams();

  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]); // yyyy-mm-dd
  const [existingStatus, setExistingStatus] = useState(null);
  const attendance = useSelector((state) => state.labor.attendance[workerId]) || {};
  const [justMarked, setJustMarked] = useState(false); // 🟢 Local override

  // useEffect(() => {
  //   if (workerId) dispatch(getWorkerAttendance(workerId));
  // }, [dispatch, workerId]);

  useEffect(() => {
    if (justMarked) return; // 🛑 Don't override if we just marked
    if (attendance[selectedDate]) {
      setExistingStatus(attendance[selectedDate]);
    } else {
      setExistingStatus(null);
    }
  }, [attendance, selectedDate, justMarked]);

  const handleMarkAttendance = async (status) => {
    setJustMarked(true);
    setExistingStatus(status); // instant UI feedback

    const resultAction = await dispatch(markIndividualAttendance({
      workerId,
      data: { projectId, date: selectedDate, status }
    }));

    if (markIndividualAttendance.fulfilled.match(resultAction)) {
      await dispatch(getWorkerAttendance(workerId));
      setTimeout(onClose, 300);
    } else {
      setJustMarked(false); // rollback override on failure
    }
  };



  return (
    <div className="mark-attendance-modal-overlay">
      <div className="mark-attendance-modal">
        <div className="modal-header">
          <h3>Mark Attendance</h3>
          <button onClick={onClose}>X</button>
        </div>

        <div className="date-selector">
          <label>
            <FaCalendarAlt />{' '}
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => {
                setSelectedDate(e.target.value);
                setJustMarked(false); // Reset override on date change
              }}
            />
          </label>
        </div>

        {existingStatus ? (
          <p className="status-info">
            Already marked as <strong>{existingStatus.toUpperCase()}</strong> on <strong>{selectedDate}</strong>.
          </p>
        ) : (
          <p className="mark-label">
            Mark <strong>{workerName}</strong>'s attendance for <strong>{selectedDate}</strong>:
          </p>
        )}

        <div className="status-buttons">
          <button onClick={() => handleMarkAttendance('present')}>Mark Present</button>
          <button onClick={() => handleMarkAttendance('absent')}>Mark Absent</button>
          <button onClick={() => handleMarkAttendance('leave')}>On Leave</button>
        </div>
      </div>
    </div>
  );
};

export default MarkAttendanceModal;
